export default __webpack_public_path__ + "static/intern-0a7cd162ae3d064e63e1c2809bed5225.png";